<template>
    <div>
        <div class="contentMenu">
            <div class="menuItem" @click="changeSection('agreement')" :class="{'active': section === 'agreement'}">Līguma informācija</div>
            <div class="menuItem" @click="changeSection('items')" :class="{'active': section === 'items'}">Priekšmeti</div>
        </div>
        <div class="content">
            <div class="loader" v-if="loading">
                <img src="/images/loading.svg" alt="Loading">
            </div>
            <div class="main">
                <div v-if="section== 'agreement'" class="section">
                    <div class="sectionTitle">Licences līguma informācija</div>
                    <div class="sectionContent">
                        <div class="subsection">
                            <div class="title">
                                Pamatinformācija
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-3">
                                <div class="form-group">
                                    <label for="agreement_number">Līguma numurs</label>
                                    <input type="text" id="agreement_number" v-model="agreement_number" class="form-control">
                                </div>
                            </div>
                            <div class="col-3">
                                <div class="form-group">
                                    <label for="agreement_date">Līguma datums</label>
                                    <v-date-picker
                                        :popover="{ visibility: 'click' }"
                                        mode="single"
                                        v-model="agreement_date"
                                        :type="'date'"
                                        :locale="'LV'"
                                        color="teal"
                                        :masks="{
                                            input: ['DD.MM.YYYY']
                                        }"
                                    />
                                </div>
                            </div>
                            <div class="col-3">
                                <div class="form-group">
                                    <label for="start_date">Sākuma datums</label>
                                    <v-date-picker
                                        :popover="{ visibility: 'click' }"
                                        mode="single"
                                        v-model="start_date"
                                        :type="'date'"
                                        :locale="'LV'"
                                        color="teal"
                                        :masks="{
                                            input: ['DD.MM.YYYY']
                                        }"
                                    />
                                </div>
                            </div>
                            <div class="col-3">
                                <div class="form-group">
                                    <label for="end_date">Beigu datums</label>
                                    <v-date-picker
                                        :popover="{ visibility: 'click' }"
                                        mode="single"
                                        v-model="end_date"
                                        :type="'date'"
                                        :locale="'LV'"
                                        color="teal"
                                        :masks="{
                                            input: ['DD.MM.YYYY']
                                        }"
                                    />
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-group">
                                    <label for="purpose">Mērķis</label>
                                    <input type="text" id="purpose" v-model="purpose" class="form-control">
                                </div>
                            </div>

                        </div>

                        <div class="subsection">
                            <div class="title">
                                Muzeja puses dati
                            </div>
                            <div class="actions">
                                <div class="actions">
                                    <button class="btn-sm btn-primary" @click="populateWithSignerData()">Aizpildīt ar noklusējuma parakstītāju</button>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-4">
                                <div class="form-group">
                                    <label for="giver_firstname">Vārds</label>
                                    <input type="text" id="giver_firstname" v-model="giver_firstname" class="form-control">
                                </div>
                            </div>
                            <div class="col-4">
                                <div class="form-group">
                                    <label for="giver_lastname">Uzvārds</label>
                                    <input type="text" id="giver_lastname" v-model="giver_lastname" class="form-control">
                                </div>
                            </div>
                            <div class="col-4">
                                <div class="form-group">
                                    <label for="giver_position">Amats</label>
                                    <input type="text" id="giver_position" v-model="giver_position" class="form-control">
                                </div>
                            </div>
                            <div class="col-4">
                                <div class="form-group">
                                    <label for="giver_legal_basis">Juridiskais pamats</label>
                                    <input type="text" id="giver_legal_basis" v-model="giver_legal_basis" class="form-control">
                                </div>
                            </div>
                        </div>

                        <div class="subsection">
                            <div class="title">
                                Otrās puses dati
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <div class="form-group">
                                    <label for="receiver_type">Personas veids</label>
                                    <select name="receiver_type" id="receiver_type" v-model="receiver_type" class="form-control">
                                        <option value="legal_person">Juridiska persona</option>
                                        <option value="individual">Fiziska persona</option>
                                    </select>
                                </div>
                            </div>
                            <hr>
                            <div class="col-3" v-if="receiver_type == 'legal_person'">
                                <div class="form-group">
                                    <label for="receiver_institution_name">Institūcijas nosaukums</label>
                                    <input type="text" id="receiver_institution_name" v-model="receiver_institution_name" class="form-control">
                                </div>
                            </div>
                            <div class="col-3" v-if="receiver_type == 'legal_person'">
                                <div class="form-group">
                                    <label for="receiver_position">Amats</label>
                                    <input type="text" id="receiver_position" v-model="receiver_position" class="form-control">
                                </div>
                            </div>
                            <div class="col-3">
                                <div class="form-group">
                                    <label for="receiver_firstname">Vārds</label>
                                    <input type="text" id="receiver_firstname" v-model="receiver_firstname" class="form-control">
                                </div>
                            </div>
                            <div class="col-3">
                                <div class="form-group">
                                    <label for="receiver_lastname">Uzvārds</label>
                                    <input type="text" id="receiver_lastname" v-model="receiver_lastname" class="form-control">
                                </div>
                            </div>
                            <div class="col-3">
                                <div class="form-group">
                                    <label for="receiver_address">Adrese</label>
                                    <input type="text" id="receiver_address" v-model="receiver_address" class="form-control">
                                </div>
                            </div>
                            <div class="col-3">
                                <div class="form-group">
                                    <label for="receiver_reg_number">Reģ.Nr. / Pers.kods</label>
                                    <input type="text" id="receiver_reg_number" v-model="receiver_reg_number" class="form-control">
                                </div>
                            </div>
                            <div class="col-4">
                                <div class="form-group">
                                    <label for="receiver_bank_title">Bankas nosaukums</label>
                                    <input type="text" id="receiver_bank_title" v-model="receiver_bank_title" class="form-control">
                                </div>
                            </div>
                            <div class="col-4">
                                <div class="form-group">
                                    <label for="receiver_bank_code">Bankas kods</label>
                                    <input type="text" id="receiver_bank_code" v-model="receiver_bank_code" class="form-control">
                                </div>
                            </div>
                            <div class="col-4">
                                <div class="form-group">
                                    <label for="receiver_bank_account_number">Bankas konts</label>
                                    <input type="text" id="receiver_bank_account_number" v-model="receiver_bank_account_number" class="form-control">
                                </div>
                            </div>
                        </div>
                        <hr>
                        <div class="row">
                            <div class="col-12 text-right">
                                <button class="btn btn-primary" @click="save()">Saglabāt līguma informāciju</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="section== 'items'" class="section">
                    <div class="sectionTitle">Priekšmeti</div>
                    <div class="sectionContent">
                        <div class="actions">
                            <items-search-component></items-search-component>
                        </div>
                        <table class="table">
                            <thead class="bg-primary text-white">
                            <tr>
                                <th>Attēls</th>
                                <th>Numurs</th>
                                <th>Nosaukums</th>
                                <th>Kolekcija</th>
                                <th>Apraksts</th>
                                <th>Darbības</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="item in items" :key="item.id">
                                <td style="width:120px;"><img v-if="item.featured_image != null" :src="'/image/thumb/'+item.featured_image.file_name"></td>
                                <td style="width:120px;">
                                    {{item.cipher}} {{item.item_number}}<span v-if="item.item_subnumber">-{{item.item_subnumber}}</span>
                                </td>
                                <td><span v-if="item.title">{{item.title.title}}</span></td>
                                <td><span v-if="item.collection">{{item.collection.title}}</span></td>
                                <td>{{item.description}}</td>
                                <td>
                                    <div class="actions">
                                        <item-view-component
                                            :key="'view-component-'+item.id"
                                            :item="item"
                                            :user="user"
                                        ></item-view-component>
                                        <div @click="removeFromList(item.id)" class="delete" ><span class="material-icons">close</span></div>
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <div v-if="items.length === 0" class="alert alert-info text-center">Sarakstā nav neviens priekšmets. Izmantojiet <strong>priekšmetu meklētāju</strong>, lai meklētu un pievienotu jaunus priekšmetus.</div>

                    </div>
                </div>
            </div>
            <div class="sidebar">
                <div class="section">
                    <div class="sectionTitle">Darbības</div>
                    <div class="sectionContent text-center">
                        <div class="col-12">
                            <button class="btn btn-primary" @click="save()">Saglabāt</button>
                        </div>
                        <hr>
                        <a :href="'/licences/generate-agreement/'+id" class="btn btn-primary" target="_blank" >Ģenerēt līgumu</a>
                        <br>
                        <br>
                      <a :href="'/licences/generate-agreement/'+id+'?edoc=1'" class="btn btn-primary" target="_blank" >Ģenerēt el. līgumu</a>
                    </div>
                </div>
                <div class="section" v-if="section=='items'">
                    <div class="sectionTitle">Pievienošana</div>
                    <div class="sectionContent">
                        <div class="row">
                            <div class="col-12 text-left">
                                <div class="form-group">
                                    <get-from-external-act></get-from-external-act>
                                </div>
                                <div class="form-group">
                                    <get-from-internal-act></get-from-internal-act>
                                </div>
                                <div class="form-group">
                                    <researchers-lists></researchers-lists>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@use "sass:color";
@import '../../../sass/variables';
.itemActions{
    width:150px;
    display:flex;
    align-items: center;
    justify-content: center;
    .action{
        cursor:pointer;
        padding:15px;
        &.view{
            color:$blue;
        }
        &.delete{
            color:$red;
        }
    }
}
.actions{
    display:flex;
    justify-content: flex-end;
    margin-bottom:20px;
}
.content{
    position:relative;
    display:flex;
    .main{
        flex-basis:800px;
        flex-grow:1;
    }
    .sidebar{
        flex-basis:400px;
        flex-grow:0;
        flex-shrink:0;
        margin-left:30px;
    }
}
.section{
    box-shadow: 0 1px 10px rgba(0,0,0,.1);
    margin:15px 0;
    .subsection
    {
        width:100%;
        display:flex;
        align-items: center;
        padding-bottom:5px;
        padding-top:10px;
        border-bottom:solid 5px #eee;
        margin-bottom:15px;
        .title{
            font-size:18px;
            font-weight:bold;
        }
        .actions{
            margin-left:auto;
        }
    }
    hr{
        width:100%;
        display:block;
    }
    .sectionTitle{
        cursor:pointer;
        font-size:16px;
        font-weight: 700;
        text-transform: uppercase;
        padding:15px 20px;
        background-color:$blue;
        color:#fff;
    }
    .sectionContent{
        width:100%;
        padding:10px 20px 20px 20px;
        img{
            width:100px;
            height:auto;
        }
    }
}
</style>

<script>
import ItemViewComponent from "../items/ItemViewComponent";
export default{
    components: {ItemViewComponent},
    props:['agreement','current_user','settings','user'],
    mounted()
    {
        this.items=this.$props.agreement.items;
        this.id = this.$props.agreement.id;
        this.agreement_number = this.$props.agreement.agreement_number;
        this.agreement_date = moment(this.$props.agreement.agreement_date, moment.ISO_8601)._d;
        this.giver_firstname = this.$props.agreement.giver_firstname;
        this.giver_lastname = this.$props.agreement.giver_lastname;
        this.giver_position = this.$props.agreement.giver_position;
        this.giver_legal_basis = this.$props.agreement.giver_legal_basis;
        this.receiver_type = this.$props.agreement.receiver_type;
        this.receiver_institution_name = this.$props.agreement.receiver_institution_name;
        this.receiver_position = this.$props.agreement.receiver_position;
        this.receiver_firstname = this.$props.agreement.receiver_firstname;
        this.receiver_lastname = this.$props.agreement.receiver_lastname;
        this.receiver_address = this.$props.agreement.receiver_address;
        this.receiver_reg_number = this.$props.agreement.receiver_reg_number;
        this.purpose = this.$props.agreement.purpose;
        this.start_date = moment(this.$props.agreement.start_date, moment.ISO_8601)._d;
        this.end_date = moment(this.$props.agreement.end_date, moment.ISO_8601)._d;
        this.price = this.$props.agreement.price;
        this.receiver_bank_title = this.$props.agreement.receiver_bank_title;
        this.receiver_bank_code = this.$props.agreement.receiver_bank_code;
        this.receiver_bank_account_number = this.$props.agreement.receiver_bank_account_number;


        var that = this;
        EventBus.$on('add_item_to_list',item_id =>{
            axios.post('/licences/add-item-to-list/'+that.id,
                {
                    item_id: item_id
                }).then(response =>{
                if(response.data.status == 'ok')
                {
                    that.items = response.data.agreement.items;
                    that.$toast.open(response.data.message);
                }
                if(response.data.status == 'info')
                {
                    that.$toast.warning(response.data.message);
                }
                if(response.data.status == 'error')
                {
                    that.$toast.warning(response.data.message);
                }
            });
        });
        EventBus.$on('add_items_to_list',items_ids =>{
            axios.post('/licences/add-items-to-list/'+that.id,
                {
                    items_ids: items_ids
                }).then(response =>{
                if(response.data.status == 'ok')
                {
                    that.items = response.data.agreement.items;
                    that.$toast.open(response.data.message);
                }
            });
        });

        EventBus.$on('open_next_item_view_modal', (current_item_id) =>{
            that.openNextItemViewModal(current_item_id);
        });
        EventBus.$on('open_prev_item_view_modal', (current_item_id) =>{
            that.openPrevItemViewModal(current_item_id);
        });
    },
    methods:{
        populateWithSignerData()
        {
            this.giver_firstname = this.getSetting('agreement_receiver_firstname');
            this.giver_lastname = this.getSetting('agreement_receiver_lastname');
            this.giver_position = this.getSetting('agreement_receiver_position');
            this.giver_legal_basis = this.getSetting('agreement_receiver_legal_basis');

        },
        getSetting(key)
        {
            var found = false;
            for(var i = 0; i < this.settings.length; i++) {
                if (this.settings[i].setting_name == key) {
                    found = true;
                    return this.settings[i].setting_value;
                }
            }
            return "";
        },
        changeSection(section)
        {
            this.section = section;
        },
        openPrevItemViewModal(item_id)
        {
            var index = this.items_list.findIndex(item => item === item_id)-1;
            if(index >= 0)
            {
                $('#view-'+this.items_list[index+1]).modal('hide');
                $('#view-'+this.items_list[index]).modal('show');
            }
            else {
                $('#view-'+this.items_list[index+1]).modal('hide');
            }
        },
        openNextItemViewModal(item_id)
        {
            var index = this.items_list.findIndex(item => item === item_id)+1;
            if(index < this.items_list.length)
            {
                $('#view-'+this.items_list[index-1]).modal('hide');
                $('#view-'+this.items_list[index]).modal('show');
            }
            else{
                $('#view-'+this.items_list[index-1]).modal('hide');
            }
        },
        normalDateTime(date)
        {
            return moment(date).format('DD.MM.YYYY. HH:mm')
        },
        normalDate(date)
        {
            return moment(date).format('DD.MM.YYYY.')
        },
        removeFromList(item_id)
        {
            var that = this;
            that.$swal.fire({
                title: 'Vai tiešām vēlaties dzēst priekšmetu no saraksta?',
                text: "Priekšmets tiks dzēsts no saraksta.",
                icon: 'error',
                showCancelButton: true,
                confirmButtonColor: '#E53935',
                cancelButtonColor: '#888787',
                confirmButtonText: 'Dzēst',
                cancelButtonText: 'Atcelt'
            }).then((result) => {
                    if (result.value) {
                        axios.post('/licences/remove-item-from-list/' + that.id,
                            {
                                item_id: item_id
                            }).then(response => {
                            if (response.data.status == 'ok') {
                                that.items = response.data.agreement.items;
                                that.$toast.open(response.data.message);
                            }
                            if (response.data.status == 'info') {
                                that.$toast.warning(response.data.message);
                            }
                            if (response.data.status == 'error') {
                                that.$toast.warning(response.data.message);
                            }
                        });
                    }});
        },

      save()
      {
          var that = this;
          var data = {
              agreement_number: this.agreement_number,
              agreement_date: this.agreement_date,
              giver_firstname: this.giver_firstname,
              giver_lastname: this.giver_lastname,
              giver_position: this.giver_position,
              giver_legal_basis: this.giver_legal_basis,
              receiver_type: this.receiver_type,
              receiver_institution_name: this.receiver_institution_name,
              receiver_position: this.receiver_position,
              receiver_firstname: this.receiver_firstname,
              receiver_lastname: this.receiver_lastname,
              receiver_address: this.receiver_address,
              receiver_reg_number: this.receiver_reg_number,
              purpose: this.purpose,
              start_date: this.start_date,
              end_date: this.end_date,
              price: this.price,
              receiver_bank_title: this.receiver_bank_title,
              receiver_bank_code: this.receiver_bank_code,
              receiver_bank_account_number: this.receiver_bank_account_number,
          }
          axios.post('/licences/update/'+that.id, data).then(response =>{
              if(response.data.status == 'ok')
              {
                  that.loading = false;
                  that.$toast.open(response.data.message);
              }
              else {
                  that.$toast.error(response.data.message);
              }
          });

      }
    },
    data()
    {
        return{
            id:"",
            agreement_number:"",
            agreement_date:"",
            giver_firstname:"",
            giver_lastname:"",
            giver_position:"",
            giver_legal_basis:"",
            receiver_type:"",
            receiver_institution_name:"",
            receiver_position:"",
            receiver_firstname:"",
            receiver_lastname:"",
            receiver_address:"",
            receiver_reg_number:"",
            purpose:"",
            start_date:"",
            end_date:"",
            price:"",
            receiver_bank_title:"",
            receiver_bank_code:"",
            receiver_bank_account_number:"",
            items:[],
            section:"agreement",
            loading:false,

        }
    },
    computed:{
        items_list()
        {
            var that = this;
            if(that.items)
            {
                return that.items.map(item =>{
                    return item.id;
                });

            }
        }

    }
}
</script>
